var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioDefualtUnmute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 53,
    viewBox: "0 0 71 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1416 13.7917C65.221 13.1053 66.6524 13.4238 67.3388 14.5032C72.1794 22.115 72.1794 31.8006 67.3388 39.4124C66.6524 40.4918 65.221 40.8103 64.1416 40.1239C63.0623 39.4375 62.7437 38.0061 63.4301 36.9267C67.3062 30.8317 67.3062 23.0839 63.4301 16.9889C62.7437 15.9095 63.0623 14.4781 64.1416 13.7917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.766 18.3394C55.7588 17.5328 57.2174 17.6837 58.024 18.6764C62 23.5699 62 30.6002 58.024 35.4937C57.2174 36.4864 55.7588 36.6373 54.766 35.8307C53.7733 35.0241 53.6224 33.5655 54.429 32.5727C57.0222 29.3811 57.0222 24.789 54.429 21.5974C53.6224 20.6047 53.7733 19.146 54.766 18.3394Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3812 1.0655C41.0447 -0.0798543 38.2232 0.114795 36.0893 1.67823L15.8845 14.5359H7.08417C3.18371 14.5359 0.0307617 17.6888 0.0307617 21.5893V31.064C0.0307617 34.9645 3.18371 38.1174 7.08417 38.1174H15.8845L36.0892 50.975C38.1942 52.5177 41.0191 52.7845 43.3974 51.5798C45.8044 50.3922 47.2991 47.9404 47.2991 45.2761V7.37717C47.2991 4.70687 45.7977 2.25009 43.3812 1.0655ZM38.7995 5.43518C39.4987 4.90691 40.4876 4.80575 41.3423 5.22475C42.1472 5.61929 42.6671 6.44708 42.6671 7.37717V45.2761C42.6671 46.2062 42.1472 47.034 41.3423 47.4285L41.3098 47.4448C40.5011 47.8571 39.524 47.7655 38.7995 47.2181C38.75 47.1807 38.6991 47.1453 38.6467 47.112L18.875 34.53V18.1232L38.6467 5.54124C38.6991 5.50794 38.75 5.47256 38.7995 5.43518ZM14.2429 19.1679H7.08417C5.74195 19.1679 4.66285 20.247 4.66285 21.5893V31.064C4.66285 32.4062 5.74195 33.4853 7.08417 33.4853H14.2429V19.1679Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDefualtUnmute);
export default __webpack_public_path__ + "static/media/audio-defualt-unmute.b1c21edbb127f6366ce79c179cd2eab3.svg";
export { ForwardRef as ReactComponent };